












































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Apps from '@/store/modules/Apps';
import AppsSubscribeButton from '@/components/apps/AppsSubscribeButton.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Users from '@/store/modules/Users';
import ValueTypes from '@/utils/ValueTypes';
import { API, Storage } from 'aws-amplify';
import { Urls } from "@/Urls";

const workspaceOptionsModule = getModule(WorkspaceOptions);
const appModule = getModule(Apps);

@Component({
    name: 'AppTemplateCard',
    components: {
        AppsSubscribeButton,
    },
    directives: {},
})
export default class AppTemplateCard extends Vue {
    private DEFAULT_IMAGE_URL = ValueTypes.DEFAULT_IMAGE_URL;
    @Prop({
        default: () => {
            return {};
        },
        type: Object,
    })
    item!: any;

    @Prop({default:false, type:Boolean})
    isMarket!:boolean;

    @Prop({default: true, type: Boolean})
    linkNewWindow: boolean;

    private noImageUrl = this.DEFAULT_IMAGE_URL.CARD_DEFAULT;
    private imageUrl ='' ;
    private copiedTooltip = false;

    mounted(){
        
    }

    private async getImage(){
        if( this.item && this.item.tileViewImage){
            let res = await Storage.get(this.item.tileViewImage);
            this.imageUrl = await res.toString();
        }
    }
    get appTemplateDetailsDict() {
        return appModule.appTemplateDetailsDictionary;
    }
    
    get currentUserId() {
        if (getModule(Users).currentUserProfile) {
            return getModule(Users).currentUserProfile.userId;
        } else {
            return undefined;
        }
    }
       get url() {
        return this.$router.currentRoute.path;
    }

     private getAppsUrl(url: string) {

        let mainPath: string;
        if(url.substring(0,5).toLowerCase() === Urls.APP_EMBED){
            mainPath = Urls.APP_EMBED;
        }else{
            mainPath = Urls.APP_EMBED;
        }
        // Remove trailing '/' if there
        mainPath = mainPath.charAt(mainPath.length - 1) == '/' ? 
            mainPath.substr(0, mainPath.length - 1) : mainPath

        let re = new RegExp(
            '^(http:|https:){1}[/]{2}([a-zA-Z0-9.:-]*[/]{0})([/]{1}[/]*){1}'
        );
        if (re.test(url)) {
            url = mainPath + url.replace(re, '/');
            // console.log(url);
            return url;
        } else {
            // console.log(url);
            return mainPath + url;
        }
    }

    private generateLink(item: any) {

        // let link = Urls.DOMAIN;
        let link = '';
        if(item.children && item.children.length > 0) {
            link = `${link}${this.getAppsUrl(item?.children[0].href)}`;
            link = `${link}&homepage=${item.homepage && item.showHomepage}&pinnedLeft=true&appEmbedId=${item.id}&appEmbedMenuId=${item.id}`
            return 'https://viewpoint-ai.com/launch?' + encodeURIComponent(link);
        }
        
    }

    private checkItem() {
        console.log(this.item)
        return true;
    }

    private copy() {
        this.copiedTooltip = true;
        setTimeout(() => (this.copiedTooltip = false), 2500);
    }
}
